import client from 'api/client';
import { ClientPaymentStatus } from 'api/models/payload/ClientPaymentStatus';

export function post(id: number, payload: ClientPaymentStatus) {
    return client.post<ClientPaymentStatus>(`/client_payment_status/${id}`, payload);
}
